
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { SupplierForm } from './SupplierForm';

interface Supplier {
  id: string;
  name_ar: string;
  name_en: string;
  employee_name_ar: string;
  employee_name_en: string;
  mobile: string;
  country: string;
  departments: string;
  email: string;
  access_permission: boolean;
  created_at: string;
  updated_at: string;
}

interface SupplierDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  supplier: Supplier | null;
  onClose: () => void;
}

export function SupplierDialog({ open, onOpenChange, supplier, onClose }: SupplierDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {supplier ? 'تعديل المورد' : 'إضافة مورد جديد'}
          </DialogTitle>
        </DialogHeader>

        <SupplierForm supplier={supplier} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}
